import { render, staticRenderFns } from "./Patents.vue?vue&type=template&id=084c8795"
import script from "./Patents.vue?vue&type=script&lang=js"
export * from "./Patents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports